



import { Vue, Component } from "vue-property-decorator";
import OrderThanks from "@/components/cutomer/orderThanks.vue";
import VueScrollTo from "vue-scrollto";

@Component({
  name: "CustomerOrderThanks",
  components: {
    OrderThanks,
  },
})
export default class CustomerOrder extends Vue {
  mounted() {
    VueScrollTo.scrollTo({ force: true });
  }
  get orderId() {
    return this.$route.params.id;
  }
}
